import HomePage from "../Storefront/pages/HomePage"
import NotFoundPage from "./NotFoundPage"

// The storefront home replaces the scaffold index page; the rest of the URL
// map lives in components/Storefront/routes.js.
export default {
  "/": HomePage,
  "/404": NotFoundPage,
}
